import * as React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import Footer from '../components/Footer';

const TermsOfService: React.FC = () => {
  const navigate = useNavigate();
  
  return (
    <HelmetProvider>
      <div>
        <Helmet>
          <title>Terms of Service | RoastMyListing.ai</title>
          <meta name="description" content="Terms of Service for RoastMyListing.ai - The rules of the roast" />
        </Helmet>
        
        {/* Header with logo */}
        <div style={{ 
          width: '100%', 
          backgroundColor: '#3b82f6',
          background: 'linear-gradient(135deg, #4f46e5 0%, #3b82f6 100%)',
          padding: '8px 0', 
          marginBottom: '2px',
          boxShadow: '0 1px 4px rgba(66, 133, 244, 0.2)'
        }}>
          <div style={{
            maxWidth: '1200px',
            margin: '0 auto',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '0 20px',
            gap: '4px' 
          }}>
            <div 
              onClick={() => navigate('/')}
              style={{ 
                cursor: 'pointer',
                display: 'inline-block',
                textAlign: 'center',
                marginBottom: '0'
              }}
            >
              <img 
                src="/logo.png" 
                alt="RoastMyListing.ai Logo"
                style={{ 
                  maxWidth: '300px', 
                  height: 'auto'
                }}
              />
            </div>
          </div>
        </div>
        
        {/* Main content */}
        <div style={{ 
          maxWidth: '900px', 
          margin: '40px auto', 
          padding: '0 20px',
          color: '#333',
          lineHeight: '1.6'
        }}>
          <h1 style={{ 
            fontSize: '2.5rem', 
            marginBottom: '30px',
            textAlign: 'center',
            color: '#1f2937'
          }}>
            Terms of Service
          </h1>
          
          <div style={{ marginBottom: '30px' }}>
            <p style={{ marginBottom: '15px' }}>
              <strong>Last Updated:</strong> March 21, 2025
            </p>
            
            <h2 style={{ fontSize: '1.5rem', margin: '30px 0 15px', color: '#374151' }}>1. Acceptance of Terms</h2>
            <p>
              By accessing or using RoastMyListing.ai, you agree to be bound by these Terms of Service and all applicable laws and regulations. If you do not agree with any of these terms, you are prohibited from using or accessing this site.
            </p>
            
            <h2 style={{ fontSize: '1.5rem', margin: '30px 0 15px', color: '#374151' }}>2. Company Information</h2>
            <p>
              RoastMyListing.ai is operated by Sellers Arena Inc. DBA Seller Synapse ("Company," "we," "us," or "our"). Our contact email is support@sellersarena.com.
            </p>
            
            <h2 style={{ fontSize: '1.5rem', margin: '30px 0 15px', color: '#374151' }}>3. Services Description</h2>
            <p>
              RoastMyListing.ai provides analytical feedback and suggestions for Amazon product listings. The service uses AI and data analysis to provide insights about listing quality and potential improvements.
            </p>
            
            <h2 style={{ fontSize: '1.5rem', margin: '30px 0 15px', color: '#374151' }}>4. Service Modifications</h2>
            <p>
              We reserve the right to modify or discontinue, temporarily or permanently, the Service (or any part thereof) with or without notice at any time. This includes the right to change from a free to a paid model if the current business model cannot be sustained.
            </p>
            
            <h2 style={{ fontSize: '1.5rem', margin: '30px 0 15px', color: '#374151' }}>5. Affiliate Links and Financial Relationships</h2>
            <p>
              RoastMyListing.ai is a participant in the Amazon Associates Program, an affiliate advertising program designed to provide a means for sites to earn advertising fees by advertising and linking to Amazon.com. We may also participate in other affiliate programs with other websites.
            </p>
            <p>
              This means that we may earn a commission when you click on or make purchases via links to Amazon or other third-party websites. These affiliate relationships do not affect our reviews, opinions, or recommendations.
            </p>
            
            <h2 style={{ fontSize: '1.5rem', margin: '30px 0 15px', color: '#374151' }}>6. Disclaimer of Warranties</h2>
            <p>
              The Service is provided on an "AS IS" and "AS AVAILABLE" basis. The Company disclaims all warranties of any kind, whether express or implied, including but not limited to the implied warranties of merchantability, fitness for a particular purpose, and non-infringement.
            </p>
            <p>
              We do not guarantee that:
            </p>
            <ul style={{ marginLeft: '20px', marginTop: '10px' }}>
              <li>The Service will meet your specific requirements</li>
              <li>The Service will be uninterrupted, timely, secure, or error-free</li>
              <li>The results that may be obtained from the use of the Service will be accurate or reliable</li>
              <li>The quality of any products, services, information, or other material purchased or obtained by you through the Service will meet your expectations</li>
              <li>Any errors in the Service will be corrected</li>
            </ul>
            
            <h2 style={{ fontSize: '1.5rem', margin: '30px 0 15px', color: '#374151' }}>7. Limitation of Liability</h2>
            <p>
              In no event shall the Company, its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from your access to or use of or inability to access or use the Service.
            </p>
            
            <h2 style={{ fontSize: '1.5rem', margin: '30px 0 15px', color: '#374151' }}>8. Amazon Relationship Disclosure</h2>
            <p>
              RoastMyListing.ai is not endorsed by, directly affiliated with, maintained, authorized, or sponsored by Amazon. All product and company names are the registered trademarks of their original owners. The use of any trade name or trademark is for identification and reference purposes only and does not imply any association with the trademark holder.
            </p>
            
            <h2 style={{ fontSize: '1.5rem', margin: '30px 0 15px', color: '#374151' }}>9. Governing Law</h2>
            <p>
              These Terms shall be governed and construed in accordance with the laws of the United States, without regard to its conflict of law provisions.
            </p>
            
            <h2 style={{ fontSize: '1.5rem', margin: '30px 0 15px', color: '#374151' }}>10. Changes to Terms</h2>
            <p>
              We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material we will try to provide at least 30 days' notice prior to any new terms taking effect. What constitutes a material change will be determined at our sole discretion.
            </p>
            
            <h2 style={{ fontSize: '1.5rem', margin: '30px 0 15px', color: '#374151' }}>11. Contact Us</h2>
            <p>
              If you have any questions about these Terms, please contact us at support@sellersarena.com.
            </p>
          </div>
        </div>
      </div>
    </HelmetProvider>
  );
};

export default TermsOfService;
